
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { Lavorazione, GruppoLavorazioniPerStagione, Utente, FinderGruppoLavorazioniPerStagione, TextValueItem } from '@/models';
import { store, StoreActions } from '@/store';
import { Loading } from '@/components';
import { LoadingTemplateType } from './enums/LoadingTemplateType';
import { MultiSelectDescriptor } from '@/models/finders/MultiSelectDescriptor';

@Component({
  components: {
    Loading,
    FilterPopup: () => import('@/components/shared/FilterPopup.vue'),
    ProgressBar: () => import('@/components/shared/ProgressBar.vue')
  }
})
export default class GruppoLavorazionePerStagioneTabella extends Vue {
    get page(): number { return store.state.uiGruppoLavorazioniPerStagione.pagina; }
    set page(value: number) { this.caricaGruppoLavorazioniPerStagione(value); }

    get itemsPerPage(): number {return store.state.uiGruppoLavorazioniPerStagione.dimensionePaginaListe }
    get pageCount(): number { return store.state.uiGruppoLavorazioniPerStagione.totPagine; }
    get numTotOrdini(): number { return store.state.uiGruppoLavorazioniPerStagione.totGruppi; }
    get user() { return store.state.currentUsr; }
    get userIsAdmin() {
        return (
        this.user.roles.find((x: string) => x.toLowerCase() == 'admin') !=
        undefined
        );
    }
    get loading () {
        return store.state.uiGruppoLavorazioniPerStagione.loadingGruppoLavorazioniPerStagione;
    }

    get lavorazione(): Lavorazione | undefined {
        return store.state.lavorazioneCorrente;
    }

    get loadTemplateCorrente() : LoadingTemplateType {
        return LoadingTemplateType.DataTable;
    }

    filters: any = {}
    
    get dataSourceStagioni(): TextValueItem[] {
        return store.state.uiGruppoLavorazioniPerStagioneDataSource.dataSourceStagioni;
    }

    get headers(): any[] {
        return [
            {
                text: "Progresso",
                value: "Progresso",
                align: 'center',
                sortable: false,
            },
            {
                text: "Stagione",
                value: "Stagione",
                align: 'center',
                sortable: false,
                filter: {
                    type: 'multiselect',
                    field: 'stagione',
                    dataSource: this.dataSourceStagioni
                }
            },
            {
                text: "Capi lanciati",
                value: "Capi lanciati",
                align: 'center',
                sortable: false,
            },
            {
                text: "Capi rientrati",
                value: "Capi rientrati",
                align: 'center',
                sortable: false,
            },
            {
                text: "Carico Capi",
                value: "Carico Capi",
                align: 'center',
                sortable: false,
            },
        ];
    }
    get fornitore(): Utente | undefined {
        return store.state.fornitore;
    }
    private idFornitore: string = '';
    async created() {
        if (this.userIsAdmin) {
            if(this.fornitore){
                this.idFornitore = this.fornitore.id;
                await this.caricaDataSources();
                this.caricaGruppoLavorazioniPerStagione(1);
            }
        } else {
            this.idFornitore = this.user.idFornitore;
                await this.caricaDataSources();
            this.caricaGruppoLavorazioniPerStagione(1);
        }
    }

    private caricaGruppoLavorazioniPerStagione(pagina: number): void {
        let parametri: FinderGruppoLavorazioniPerStagione = {
            numeroPagina: pagina,
            idFornitore: this.idFornitore ?? "",
            dimensionePagina: store.state.uiGruppoLavorazioniPerStagione.dimensionePaginaListe,
            stagione: "", //TODO valorizzare da filtro, se necessario
        }

        

        if( this.filters["stagione"] && this.filters["stagione"].filter &&  this.filters["stagione"].filter.length){
            parametri.filtroStagione = new MultiSelectDescriptor(this.filters["stagione"].operator, this.filters["stagione"].filter);
        }

        store.dispatch(StoreActions.GetGruppoLavorazioniPerStagione, parametri);
    }

    
    private async caricaDataSources() {
        let parametri: FinderGruppoLavorazioniPerStagione = {
            numeroPagina: 0,
            idFornitore: this.idFornitore ?? "",
            dimensionePagina: 0,
            stagione: "", //TODO valorizzare da filtro, se necessario,
        }
        await store.dispatch(StoreActions.GetGruppoLavorazioniPerStagioneDataSources, parametri)
    }

    get items(): GruppoLavorazioniPerStagione[] {
        return store.state.uiGruppoLavorazioniPerStagione.gruppoLavorazioniPerStagione;
    }

    public getProgresso(gruppo: GruppoLavorazioniPerStagione) : number{
        return Math.ceil(gruppo.capiRientrati / gruppo.capiLanciati * 100);
    }

    onSetfilter(filterItem : any) {
        this.filters[filterItem.field] = {operator: filterItem.operator, filter: filterItem.filter};
        this.caricaGruppoLavorazioniPerStagione(1);
    }

    onRemoveFilter(filterItem : any) {
        delete this.filters[filterItem.field];
        this.caricaGruppoLavorazioniPerStagione(1);
    }

    @Watch("$store.state.fornitore")
    onCambioFiltri() {
        this.idFornitore = store.state.fornitore?.id ?? "";
        this.caricaGruppoLavorazioniPerStagione(store.state.uiGruppoLavorazioniPerStagione.pagina);
    }
}

